/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable i18n-text/no-en */
import { AppImage } from '../../../../../../../../ui/AppImage';
import { AppButton } from 'src/ui/buttons/AppButton';
import { v4 as uuidv4 } from 'uuid';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { sendDataToAnalytics } from '../../../../utils/sendDataToAnalytics';
import { formatHref } from 'src/processes/CMS/processes/management/utils/helpers';
import { HamburgerMenu } from './HamburgerMenu';
import { useWindowResize } from 'src/processes/CMS/processes/management/utils/hooks/useWindowResize';

const onClickButton = url => {
  window.open(formatHref(url), '_blank');
};

const TABLET_WIDTH = 850;

// eslint-disable-next-line sonarjs/cognitive-complexity,max-lines-per-function
export function Header({ header = {}, backgroundColor, isAudioGuidePlaying, playAudio, pauseAudio, footer = {}, textLinkStyles }) {
  const { windowWidth } = useWindowResize();

  const { logo, autoGuide, isAutoGuide, showHeader } = header;

  const containerStyle = windowWidth <= TABLET_WIDTH ? { padding: '0 10px' } : { padding: '0 24px' };

  const togglePlay = () => {
    if (isAudioGuidePlaying) {
      pauseAudio();
      sendDataToAnalytics('Audio guide', 'stop audio');
    } else {
      playAudio();
      sendDataToAnalytics('Audio guide', 'play audio');
    }
  };

  const preparedButtonsLinks = footer.buttonLinks?.map(link => ({
    ...link,
    id: uuidv4(),
  }));

  /* eslint-disable */
  const numberOfHeaderLinks =
    windowWidth >= 1100
      ? 4
      : windowWidth >= 860
      ? 3
      : windowWidth >= 650
      ? 2
      : windowWidth >= 500
      ? 1
      : 0;
  /* eslint-enable */

  const menuLinks = preparedButtonsLinks?.splice(0, numberOfHeaderLinks);

  return (
    showHeader !== false && (
      <div style={{ backgroundColor }} className={styles.header}>
        <div className={styles.container} style={containerStyle}>
          {logo?.s3Url ? <AppImage className={styles.logo} alt='Logo' src={logo?.s3Url} /> : <div />}
          <div className={styles.headerLinks}>
            {menuLinks?.map(link => {
              return (
                <AppButton
                  className={styles.navButtons}
                  onClick={() => {
                    onClickButton(link.linkUrl);
                  }}
                  style={{
                    ...textLinkStyles,
                    fontFamily: textLinkStyles.font,
                    fontWeight: 700,
                    fontSize: '14px',
                    color: '#5C5C6E',
                    backgroundColor: 'transparent',
                    border: 'none',
                    boxShadow: 'none',
                  }}
                  key={link.id}
                >
                  {link?.linkIcon?.s3Url && <img src={link?.linkIcon?.s3Url} alt='link icon' />}
                  {link.linkName}
                </AppButton>
              );
            })}
            {preparedButtonsLinks && preparedButtonsLinks.length > 0 && <HamburgerMenu links={preparedButtonsLinks} />}

            {isAutoGuide && (
              <button
                onClick={togglePlay}
                tabIndex={0}
                type='button'
                className={classNames(styles.avatarButton, 'analytics-audio-guide')}
                style={{
                  marginRight: '10px',
                  marginLeft: '20px',
                  transform: isAudioGuidePlaying ? 'scale(1.2)' : '',
                }}
              >
                <AppImage
                  alt='Audio Guide'
                  src={autoGuide?.s3Url || '/images/avatar.png'}
                  className={styles.avatar}
                  style={{ pointerEvents: 'none' }}
                />
              </button>
            )}
          </div>
        </div>
      </div>
    )
  );
}
